import { render, staticRenderFns } from "./tracking.vue?vue&type=template&id=420e4c2e&"
import script from "./tracking.vue?vue&type=script&lang=js&"
export * from "./tracking.vue?vue&type=script&lang=js&"
import style0 from "./tracking.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ShipmentTrackingForm: require('/opt/cargo.front/src/components/shipment/tracking-form.vue').default,BaseLayoutPageHeader: require('/opt/cargo.front/src/components/base/layout/page-header.vue').default,RzContainer: require('/opt/cargo.front/node_modules/@razlet/ui/lib/modules/components/container/index.js').default,RzButton: require('/opt/cargo.front/node_modules/@razlet/ui/lib/modules/components/button/index.js').default,ShipmentTrackingProgress: require('/opt/cargo.front/src/components/shipment/tracking-progress.vue').default})
